import { render, staticRenderFns } from "./SupportContactIcon.vue?vue&type=template&id=500484a0&scoped=true&"
import script from "./SupportContactIcon.vue?vue&type=script&setup=true&lang=ts&"
export * from "./SupportContactIcon.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "500484a0",
  null
  
)

export default component.exports